// extracted by mini-css-extract-plugin
export default {"shadow":"Canvas_shadow__71Six","hide":"Canvas_hide__A9XHS","error":"Canvas_error__m6K8o"};